import { IBankAccountInputModel } from 'inputModels';
import { IBankAccountViewModel, IPixAccountViewModel } from 'viewModels';
import api from '../services/api/axios';

const addWalletAccountBank = async (inputModel: IBankAccountInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post('wallet/add-account-bank', inputModel)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getBankAccountById = (id: string) => {
  return new Promise<IBankAccountViewModel>((resolve, reject) => {
    api
      .get(`wallet/${id}/get-bank-account`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getAllBankAccounts = (uid: string) => {
  return new Promise<IBankAccountViewModel[]>((resolve, reject) => {
    api
      .get(`wallet/${uid}/get-bank-accounts`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const updateBankAccount = async (inputModel: IBankAccountViewModel, uid: string) =>
  new Promise((resolve, reject) => {
    api
      .put(`wallet/${uid}/update-bank-account`, inputModel)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const deleteBankAccount = async (uid: string) => {
  return api.put(`wallet/${uid}/delete-bank-account`);
};

const getPixAccounts = (id: string) => {
  return new Promise<IPixAccountViewModel[]>((resolve, reject) => {
    api
      .get(`wallet/${id}/get-pix-accounts`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(reject);
  });
};

const addWalletAccountPix = (pixAccount: FormData) => {
  return new Promise<string>((resolve, reject) => {
    api.post('wallet/add-account-pix', pixAccount, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(({ data }) => resolve(data)).catch(reject);
  })
};

const updatePixAccount = (pixAccount: FormData, uid: string) => {
  return api.put(`wallet/${uid}/update-pix-account`, pixAccount, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const deletePixAccount = async (uid: string) => {
  return api.put(`wallet/${uid}/delete-pix-account`);
};

export const WalletController = {
  addWalletAccountBank,
  getAllBankAccounts,
  getBankAccountById,
  updateBankAccount,
  deleteBankAccount,
  addWalletAccountPix,
  getPixAccounts,
  updatePixAccount,
  deletePixAccount,
};
